import React from 'react';
import { cx } from './utils';

const Badge = ({ variant = 'default', className = '', children }) => {
  const variants = {
    default: 'bg-white/90 text-slate-700 border border-white/60',
    dark: 'bg-slate-900 text-white border border-slate-900',
    accent: 'bg-[#F4EADF] text-[#8F4F1D] border border-[#E7D8C4]',
    outline: 'bg-transparent text-slate-600 border border-slate-200',
  };
  return (
    <span
      className={cx(
        'inline-flex items-center gap-1 rounded-full px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.28em]',
        variants[variant] || variants.default,
        className
      )}
    >
      {children}
    </span>
  );
};

export default Badge;
